import { FillInputByNameInstruction } from '../FillInputByNameInstruction'

export class PhoneInstruction extends FillInputByNameInstruction {
  constructor ({ waitForNoLoaders, value }) {
    super({
      name: 'Phone',
      inputName: 'telephone',
      waitForNoLoaders,
      value

    })
  }

  setDefaultValue (params) {
    this.value = params.userInformation.phone
  }
}
